import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Departamentos", icon: "fas fa-clipboard-list", color: "#3b82f6", bg: "#eff6ff", href: "/Departamentos", desc: "Departamentos administrativos", perm: "menu_departamentos" },
];

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-clipboard-list" color="#3b82f6" bg="#eff6ff" title="Catálogos" subtitle="Configuración base del sistema" />
        {user.menu_admin ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCatalogos;
